import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import { useVideo } from '../context/video/VideoContext';
import Card from '../ui-elements/Card'
import Modal from '../ui-elements/Modal'
import AddButton from '../formfields/AddButton'
import { useNavigate, useParams } from 'react-router-dom';
import RedAlert from '../ui-elements/RedAlert';
import FooterNavButtons from '../shared-components/FooterNavButtons';
import HeaderDetails from '../shared-components/HeaderDetails';
import Spinner from '../ui-elements/Spinner';
import PhotoPreview from './PhotoPreview';
import { subscribe } from '../utils/pubsub';
import { b64toBlob } from '../utils/b64toBlob';
import { error } from 'console';



type Props = {
}

function AddPhotoNote({
}: Props) {


    const {
        tableData,
        setShowModal,
        setIsVideoMode,
        isVideoPlaying,
        setIsVideoPlaying,
        sendMessageToWebsocket,
        loggedIn,
        userData,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const { answerId } = useParams()
    const [titleText, setTitleText] = useState('Take a photo note')
    const [subtitleText, setSubtitleText] = useState('')
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [thisAnswer, setThisAnswer] = useState<null | ObjectStringKeyAnyValue>(null)
    const [jpegString, setJpegString] = useState<string | null>(null)
    const { captureAsJPEGString, setQRCodesSearchOptions } = useVideo()
    const [nextButtonText, setNextButtonText] = useState('')
    const [nextButtonAction, setNextButtonAction] = useState<null | AnyFunction>(null)
    const [backButtonAction, setBackButtonAction] = useState<null | AnyFunction>(null)
    const [backButtonText, setBackButtonText] = useState('back')
    const [backButtonUrl, setBackButtonUrl] = useState(`/checklists/`)

      useEffect(() => {
        return () => {
          // code to run when the user navigates away from the page
          setIsVideoMode(false)
          setIsVideoPlaying(false)
          setJpegString(null)
        }
      }, [])

    useEffect(() => {
        if (tableData) {
            if (answerId && tableData.ChecklistAnswers && tableData.ChecklistAnswers[answerId]) {
                // get answer details
                const answerObj = tableData.ChecklistAnswers[answerId]
                setThisAnswer(answerObj)
                if (answerObj.Pending === true) {
                    setErrorMessage(t('QuestionPages.AddPhotoNote.questionNotAnswered'))
                } else if (answerObj.PhotoNoteFileName && typeof answerObj.PhotoNoteFileName === 'string') {
                    setErrorMessage(t('QuestionPages.AddPhotoNote.answerAlreadyHasPhotoNote'))
                } else {
                    console.log("Switching video on")
                    switchVideoOn()
                }
                // set header text with the question title
                const thisQuestionId = answerObj.QuestionId
                if (tableData.ChecklistQuestions && tableData.ChecklistQuestions[thisQuestionId] && tableData.ChecklistQuestions[thisQuestionId].QuestionText) {
                    setTitleText(tableData.ChecklistQuestions[thisQuestionId].QuestionText)
                    setSubtitleText(t('QuestionPages.AddPhotoNote.takePhotoNote'))
                }
            } else { setErrorMessage(t('QuestionPages.AddPhotoNote.invalidAnswerId')) }
        }
    }, [tableData, answerId])


 


    useEffect(() => {
        if (thisAnswer && jpegString && !errorMessage) {
            // photo captured
            setBackButtonAction(() => () => retakePhoto())
            setBackButtonText(t('Buttons.retake'))
            setBackButtonUrl('')
            setNextButtonAction(() => () => saveData())
            setNextButtonText(t('Buttons.savePhotoNote'))
        } else if (thisAnswer && !jpegString && !errorMessage) {
            // photo capture mode
            setBackButtonAction(null)
            setBackButtonText(t('Buttons.cancel'))
            setBackButtonUrl(`/checklists/${thisAnswer.ChecklistPeriodId}`)
            setNextButtonAction(() => () => capturePhoto())
            setNextButtonText(t('Buttons.capture'))
        } else if (thisAnswer && errorMessage) {
            setBackButtonAction(null)
            setBackButtonText(t('Buttons.cancel'))
            setBackButtonUrl(`/checklists/${thisAnswer.ChecklistPeriodId}`)
            setNextButtonAction(null)
            setNextButtonText('QuestionPages.')
        } else {
            setBackButtonAction(null)
            setBackButtonText(t('Buttons.cancel'))
            setBackButtonUrl('/checklists')
            setNextButtonAction(null)
            setNextButtonText('QuestionPages.')
        }
    }, [thisAnswer, jpegString])

    const switchVideoOn = () => {
        // console.log("Switch video on (1)")
        setIsVideoMode(true)
        setIsVideoPlaying(true)
        setQRCodesSearchOptions({ 'enabled': true })
    }

    const retakePhoto = () => {
        // console.log("Switch video on (2)")
        setJpegString(null)
        setIsVideoPlaying(true)
        setIsVideoMode(true)
    }

    const capturePhoto = () => {
        const jpgData = captureAsJPEGString(600)
        setJpegString && setJpegString(jpgData || null)
        // console.log("Switching video off")
        setIsVideoPlaying(false)
        setIsVideoMode(false)
    }



    const saveData = async () => {
        if (thisAnswer && answerId && jpegString) {
            setShowModal({ "spinner": t('General.saving') })
            const timestamp = `${Date.now()}`
            let fileName = `note-${answerId}-${timestamp}.jpg`
            await handleImageUpload(answerId, jpegString, fileName, timestamp)
        } else {
            setErrorMessage(t('QuestionPages.AddPhotoNote.couldNotSaveAnswer'))
        }
    }


    const handleImageUpload = async (answerId: string, dataString: string, fileName: string, timestamp: string) => {
        const payload = JSON.stringify({
            action: "checklistsClientApp",
            subAction: "requestPresignedUrl",
            fileName: fileName,
            waitingForUploadUrlId: timestamp
        })
        const response = new Promise<void>((resolve, reject) => {
            const unsubscribe = subscribe("returnPresignedUrl", async data => {
                if (data.waitingForUploadUrlId === timestamp) {
                    unsubscribe()
                    const prefix = 'data:image/jpeg;base64,'
                    const fileBody = dataString!.split(prefix)[1]
                    const file = new File([b64toBlob(fileBody)], timestamp, { type: "image/jpeg" })
                    await fetch(data.signedUrl, {
                        method: 'PUT',
                        body: file
                    })
                        .then(response => {
                            // send answer to websocket
                            const payload: ObjectStringKeyAnyValue = {
                                action: "checklistsClientApp",
                                subAction: "saveAnswerNote",
                                answerId: `${answerId}`,
                                photoNoteFileName: data.imageFileName
                            }
                            // if a user is logged in as a guest, add their name to the data
                            if (loggedIn === 'guest') {
                              payload['GuestUserName'] = userData.name
                            }

                            // navigate back once the answer is saved (unless its a photo upload)
                            const unsubscribe = subscribe("tableUpdateItemModified", data => {
                                console.log(data)
                                if (data.newRecord && data.newRecord.Id === answerId) {
                                    setShowModal(null)
                                    setJpegString(null)
                                    navigate(thisAnswer ? `/checklists/${thisAnswer.ChecklistPeriodId}/confirm/${thisAnswer.Id}` : `/checklists/`)
                                    unsubscribe()
                                }
                            })
                            sendMessageToWebsocket(JSON.stringify(payload))

                            return (response)
                        }).catch((error) => {
                            console.error('Error:', error)
                        })
                }
            })
        })
        sendMessageToWebsocket(payload)
        await response
    }


    


    return <div
        className={`w-full flex-1 h-full flex flex-col justify-between gap-2`}
    >




        <div className={`w-full flex flex-col items-center`}>
            <HeaderDetails
                titleText={titleText}
                instructionsText={subtitleText}
            />
            <div className={`max-w-3xl w-full p-5 flex flex-col gap-2 items-center justify-center text-center`}>
                {!tableData && <Spinner><p>{t('General.loading')}</p></Spinner>}
                {tableData && errorMessage && <RedAlert>{errorMessage}</RedAlert>}


                {jpegString && <PhotoPreview
                    jpegString={jpegString}
                />}


            </div>
        </div>




        <FooterNavButtons
            backButtonUrl={backButtonUrl}
            backButtonText={backButtonText}
            backButtonAction={backButtonAction}
            nextButtonAction={nextButtonAction}
            nextButtonText={nextButtonText}
        />

    </div>
}
export default AddPhotoNote